import React from 'react'
import { FieldProps } from 'formik'
import xor from 'lodash/xor'

type FormikMultipleCheckboxProps = {
  items: Array<{ label: string; value: string }>
}

const FormikMultipleCheckbox: React.FC<FieldProps & FormikMultipleCheckboxProps> = (props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.form.setFieldValue(props.field.name, xor(props.form.values[props.field.name], [e.target.name]))
  }

  const isChecked = (item: string): boolean => {
    return props.form.values[props.field.name].includes(item)
  }

  return (
    <div className="space-y-3">
      {props.items.map((item) => (
        <div className="relative flex items-start" key={item.value}>
          <label
            htmlFor={`${props.field.name}-${item.value.toLocaleLowerCase()}`}
            className="cursor-pointer select-none text-sm text-gray-700"
          >
            {item.label}
          </label>
          <div className="ml-auto flex h-5 items-center">
            <input
              id={`${props.field.name}-${item.value.toLocaleLowerCase()}`}
              type="checkbox"
              name={item.value}
              checked={isChecked(item.value)}
              onChange={handleChange}
              style={{ boxShadow: 'none' }}
              className="text-secondary-700 form-checkbox h-4 w-4 cursor-pointer rounded border-gray-300 focus:ring-0"
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default FormikMultipleCheckbox
